import moment from 'moment';
import { useHolidayCalendar } from 'hooks/use-holiday-calendars';
import { getHolidayArray } from 'utils/holiday-calendar-utils';
import { getStartDate, getTimeOffArray } from 'utils/time-off-utils';
/**
 * Shared availability derivation for the remaining app-owned user Select rows.
 * The caller still owns the title/tooltip presentation and option-specific
 * description semantics.
 */ export const useFlexUserOptionAvailability = ({ holidayCalendarId, timeOffDetails, startDate, dueDate, useDueDateFallback = false })=>{
    const { holidayCalendar } = useHolidayCalendar(holidayCalendarId);
    const resolvedDueDate = dueDate ? moment(dueDate) : undefined;
    const resolvedStartDate = startDate ? moment(startDate) : useDueDateFallback ? getStartDate(resolvedDueDate) : undefined;
    if (!resolvedDueDate) {
        return {
            startDate: resolvedStartDate,
            dueDate: resolvedDueDate,
            timeOffArray: [],
            holidayArray: []
        };
    }
    return {
        startDate: resolvedStartDate,
        dueDate: resolvedDueDate,
        timeOffArray: timeOffDetails ? getTimeOffArray(resolvedStartDate === null || resolvedStartDate === void 0 ? void 0 : resolvedStartDate.clone(), resolvedDueDate.clone(), timeOffDetails) : [],
        holidayArray: holidayCalendar ? getHolidayArray(resolvedStartDate === null || resolvedStartDate === void 0 ? void 0 : resolvedStartDate.clone(), resolvedDueDate.clone(), holidayCalendar.holidays) : []
    };
};
